import { isEmpty, isInteger, isString } from 'lodash';
export const defaultDurationObject = {
    hours: 0,
    minutes: 0,
};
export const defaultDurationString = 'PT0H0M';
export function parseDurationString(duration) {
    const defaultDurationObjectCopy = Object.assign({}, defaultDurationObject);
    if (!isString(duration)) {
        return defaultDurationObjectCopy;
    }
    const durationComponents = duration.match(/PT(\d+)H(?:(\d+)M)?/i);
    if (isEmpty(durationComponents)) {
        return defaultDurationObjectCopy;
    }
    let hours = parseInt(durationComponents[1], 10);
    if (!isInteger(hours) || hours < 0) {
        hours = 0;
    }
    let minutes = parseInt(durationComponents[2], 10);
    if (!isInteger(minutes) || minutes < 0) {
        minutes = 0;
    }
    return { hours, minutes };
}
export function getDurationString(duration) {
    if (!duration) {
        return defaultDurationString;
    }
    let { hours, minutes } = duration;
    if (!isInteger(hours) || hours < 0) {
        hours = 0;
    }
    if (!isInteger(minutes) || minutes < 0) {
        minutes = 0;
    }
    return `PT${hours}H${minutes}M`;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHVyYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMva2F5ZW50YS91dGlscy9kdXJhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLFNBQVMsRUFBRSxRQUFRLEVBQUUsTUFBTSxRQUFRLENBQUM7QUFPdEQsTUFBTSxDQUFDLE1BQU0scUJBQXFCLEdBQUc7SUFDbkMsS0FBSyxFQUFFLENBQUM7SUFDUixPQUFPLEVBQUUsQ0FBQztDQUNYLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRyxRQUFRLENBQUM7QUFFOUMsTUFBTSxVQUFVLG1CQUFtQixDQUFDLFFBQWdCO0lBQ2xELE1BQU0seUJBQXlCLHFCQUFRLHFCQUFxQixDQUFFLENBQUM7SUFDL0QsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsRUFBRTtRQUN2QixPQUFPLHlCQUF5QixDQUFDO0tBQ2xDO0lBQ0QsTUFBTSxrQkFBa0IsR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDLHNCQUFzQixDQUFDLENBQUM7SUFDbEUsSUFBSSxPQUFPLENBQUMsa0JBQWtCLENBQUMsRUFBRTtRQUMvQixPQUFPLHlCQUF5QixDQUFDO0tBQ2xDO0lBQ0QsSUFBSSxLQUFLLEdBQUcsUUFBUSxDQUFDLGtCQUFrQixDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLElBQUksS0FBSyxHQUFHLENBQUMsRUFBRTtRQUNsQyxLQUFLLEdBQUcsQ0FBQyxDQUFDO0tBQ1g7SUFDRCxJQUFJLE9BQU8sR0FBRyxRQUFRLENBQUMsa0JBQWtCLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDbEQsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsSUFBSSxPQUFPLEdBQUcsQ0FBQyxFQUFFO1FBQ3RDLE9BQU8sR0FBRyxDQUFDLENBQUM7S0FDYjtJQUNELE9BQU8sRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFDNUIsQ0FBQztBQUdELE1BQU0sVUFBVSxpQkFBaUIsQ0FBQyxRQUFtQjtJQUNuRCxJQUFJLENBQUMsUUFBUSxFQUFFO1FBQ2IsT0FBTyxxQkFBcUIsQ0FBQztLQUM5QjtJQUNELElBQUksRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLEdBQUcsUUFBUSxDQUFDO0lBQ2xDLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLElBQUksS0FBSyxHQUFHLENBQUMsRUFBRTtRQUNsQyxLQUFLLEdBQUcsQ0FBQyxDQUFDO0tBQ1g7SUFDRCxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxJQUFJLE9BQU8sR0FBRyxDQUFDLEVBQUU7UUFDdEMsT0FBTyxHQUFHLENBQUMsQ0FBQztLQUNiO0lBQ0QsT0FBTyxLQUFLLEtBQUssSUFBSSxPQUFPLEdBQUcsQ0FBQztBQUNsQyxDQUFDIn0=